import Model, { attr, hasMany } from '@warp-drive/legacy/model';
import type AccountingTransactionModel from './accounting-transaction.ts';
import type AccountingInvoiceModel from './accounting-invoice.ts';
import type BulkAchPaymentModel from './bulk-ach-payment.ts';
import type { Store } from '@warp-drive/core';
import { service } from '@ember/service';
import { Type } from '@warp-drive/core-types/symbols';
import './bulk-ach-payment.ts';

interface AccountingPaymentStats {
  count?: {
    invoices?: number;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export default class AccountingPaymentModel extends Model {
  @service declare store: Store;

  @attr declare paymentDate: string;
  @attr declare description: string;
  @attr declare state: string;
  @attr declare tag: string;
  @attr declare messageId: string;
  @attr declare paymentPath: string;
  @attr declare stats: AccountingPaymentStats;
  @attr declare amount: number;
  @attr declare total: number;
  @attr declare achAmount: number;
  @attr declare checkAmount: number;

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('accounting-transaction', { async: false, inverse: null })
  declare accountingTransactions: AccountingTransactionModel[];

  @hasMany('accounting-invoice', { async: false, inverse: null })
  declare accountingInvoices: AccountingInvoiceModel[];

  @hasMany('bulk-ach-payment', { async: false, inverse: null })
  declare bulkAchPayments: BulkAchPaymentModel[];

  /**************************
   **  Computed Properties **
   **************************/

  get isCreated() {
    return this.state === 'CREATED';
  }

  [Type] = 'accounting-payment' as const;
}
